import styled from 'styled-components'

import { premiumFontCss } from '@root/entities/premium/ui'
import { useTranslation } from '@root/shared/localization'

import { PremiumPurchaseBoostersBadge } from './purchase-boosters-badge'

import type { PairActivity } from '../../model'

type Props = {
  activity: PairActivity.PremiumPurchased
}

export const PremiumPurchasePremiumBadge: React.FC<Props> = ({ activity }) => {
  const { t } = useTranslation()

  return (
    <Root>
      <PremiumText>{t('common.d-premium')}</PremiumText>
      <PremiumPurchaseBoostersBadge boosters={activity.boostersAmount} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;

  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
`

const PremiumText = styled.div`
  ${premiumFontCss}
`
